export default "__VITE_ASSET__JRvmMDZH__"